import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { takeUntil } from "rxjs/operators";
import { MultiSelectorComponent } from "~app/common/components/multi-selector/multi-selector.component";

import { GridBaseComponent } from "../grid-base/grid-base.component";

@Component({
    selector: "rask-grid-multi-select-editor",
    templateUrl: "./grid-multi-select-editor.component.html",
    styleUrls: ["./grid-multi-select-editor.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MultiSelectorComponent,
        FormsModule
    ]
})
export class GridMultiSelectEditorComponent  extends GridBaseComponent implements AfterViewInit {
    @ViewChild(MultiSelectorComponent) comp: MultiSelectorComponent;

    getValue(): any {
        return this.value;
    }

    isPopup(): boolean {
        return true;
    }

    ngAfterViewInit() {
        this.comp.focus.pipe(
            takeUntil(this.destroy$)
        ).subscribe(x => {
            if (!x) {
                this.api.stopEditing();
                this.api.refreshCells();
            }
        });
    }

    afterGuiAttached() {
        if(!this.readonly) {
            this.comp.ngselect.open();
        }
    }
}
